import { useCallback, useEffect, useRef, useState } from "react";
import NavBar from "../../../components/organisms/navbar";
import {
  Content,
  InfoContainerStatus,
  InfoContainerText,
  Loader,
  PageLocationTitle,
  PageTitle,
  PageTitleContainer,
  StatusButton,
  SubscriptionActions,
  SubscriptionContainer,
  SubscriptionContent,
  SubscriptionDescription,
  SubscriptionItem,
  SubscriptionLink,
  SubscriptionList,
  SubscriptionTitle,
} from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import useAuthenticate from "../../../hooks/useAuthenticate";
import Loading from "../../../components/atoms/loading";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  Fab,
  Paper,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";
import { HistoryModal } from "src/components/atoms/historyModal";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Swal from "sweetalert2";
import HistoryIcon from "@mui/icons-material/History";
import EditIcon from "@mui/icons-material/Edit";
import { LoadingButton } from "@mui/lab";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import FederationBadge from "src/components/atoms/federationBadge";
//import { consoleLog } from "src/utils/consoleLog";

const Subscription = () => {
  const loaderRef = useRef<HTMLDivElement | null>(null);
  const [subs, setSubs] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const [search, setSearch] = useState("");
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const { getToken } = useAuthenticate();
  const [isPaymentLoading, setIsPaymentLoading] = useState<boolean>(false);
  const [selectedEnrollment, setSelectedEnrollment] = useState<number | null>(
    null
  );
  const [historyData, setHistoryData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tournaments, setTournaments] = useState<any>([]);
  const [tournamentMap, setTournamentMap] = useState<Record<number, any>>({});
  const [selectedTournament, setSelectedTournament] = useState<any>(null);
  const url = window.location.pathname;
  const navigate = useNavigate();

  const fetchSubs = useCallback(
    async (pageNumber = 1, searchTerm = "", append = false) => {
      if (loadingMore) return;
      setLoadingMore(true);

      try {
        const response = await api.get(
          `/tournaments/profile/enrollments/paginated?${new URLSearchParams({
            page: pageNumber.toString(),
            limit: "30",
            search: searchTerm,
          })}`,
          {
            headers: { Authorization: `Bearer ${getToken()}` },
          }
        );

        const newSubs = response.data.data;
        setSubs((prev: any) => (append ? [...prev, ...newSubs] : newSubs));
        setPage(response.data.meta.page);
        setTotal(response.data.meta.total);
        setLastPage(response.data.meta.lastPage);
      } catch (error: any) {
        toast.error(
          error.response?.data?.message || "Erro ao carregar suas inscrições"
        );
      } finally {
        setInitialLoading(false);
        setLoadingMore(false);
      }
    },
    [loadingMore]
  );

  const mountTournamentsSearch = () => {
    api
      .get("/tournaments/fighters/", {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((response) => {
        const arr = response.data;
        const map: Record<number, any> = {};
        arr.forEach((t: any) => {
          map[t.id] = t;
        });

        setTournaments(arr);
        setTournamentMap(map);
      });
  };

  const redirectToPagePayment = (id: number, tournamentId: number) => {
    setSelectedEnrollment(id);
    setIsPaymentLoading(true);

    const tournament = tournaments.find(
      (tournament: any) => tournament.id === tournamentId
    );

    if (tournament?.paymentManual) {
      navigate(`/payment-instruction/${tournament?.slug}/${id}`);
    }

    api
      .get(`/payments/checkout/${id}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        window.open(res.data.links[1].href, "_self");
      })
      .catch((err) => {
        console.log(err);
        navigate("/payment-instruction/" + tournament?.slug + "/" + id);
        setIsPaymentLoading(false);
      });
  };
  const showHistorySubsModal = async (subscriptionId: number) => {
    await api
      .get(`/history/Subscription/${subscriptionId}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((res) => {
        setHistoryData(res.data);
        setIsModalOpen(true);
      });
  };

  const handleEditFighter = (fighterId: number, slug: string) => {
    navigate(`/enrollment-update/${fighterId}/${slug}`);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (tournaments.length === 0) {
      mountTournamentsSearch();
    }
  }, [tournaments]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchSubs(1, search, false);
  }, []);

  // observer para infinite scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && page < lastPage && !initialLoading) {
          fetchSubs(page + 1, search, true);
        }
      },
      { threshold: 0 }
    );

    const currentLoaderRef = loaderRef.current;

    if (currentLoaderRef) {
      observer.observe(currentLoaderRef);
    }

    return () => {
      if (currentLoaderRef) {
        observer.unobserve(currentLoaderRef);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, lastPage, fetchSubs, initialLoading]);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <NavBar />
      <Container>
        <PageLocationTitle>Minhas Inscrições</PageLocationTitle>
        <PageTitle><span>{total} inscrições encontradas</span></PageTitle>

        <Autocomplete
          options={tournaments}
          getOptionLabel={(option) => option?.name?.toUpperCase()}
          value={selectedTournament}
          onChange={(event, newValue) => {
            setSelectedTournament(newValue);

            if (newValue) {
              setInitialLoading(true);
              setSearch(newValue.id);
              fetchSubs(1, newValue.id, false);
            } else {
              setInitialLoading(true);
              setSearch("");
              fetchSubs(1, "", false);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Digite para buscar um campeonato..."
              variant="outlined"
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "white",
                },
              }}
            />
          )}
          noOptionsText="Nenhum campeonato encontrado"
          loading={initialLoading}
          loadingText="Carregando campeonatos..."
          sx={{
            "& .MuiAutocomplete-paper": {
              backgroundColor: "white",
            },
          }}
        />
      </Container>

      {loadingMore && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center", // centraliza horizontalmente
            alignItems: "center", // centraliza verticalmente
            backdropFilter: "blur(6px)", // 👈 aplica o blur no fundo
            backgroundColor: "rgba(255, 255, 255, 0.4)", // leve transparência
            zIndex: 2000, // garante que fica acima de tudo
            gap: 2,
          }}
        >
          <Typography
            sx={{ fontFamily: "Inter, sans-serif", fontSize: "1.1rem" }}
          >
            Aguarde, estamos carregando suas inscrições...
          </Typography>

          <CircularProgress sx={{ color: "black" }} />
        </Box>
      )}

      <Container>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          {subs.map((subs: any) => {
            const tournamentInfo = tournamentMap[subs.tournamentId];
            const canEditSubsTournament = tournamentInfo?.canEditSubscriptions;
            const canPaySubscriptionTournament =
              tournamentInfo?.paymentPix ||
              tournamentInfo?.paymentCredicard ||
              tournamentInfo?.paymentManual;

            return (
              <Paper
                key={subs.id}
                sx={{
                  p: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {/* Coluna esquerda */}
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    sx={{ fontFamily: "inter, sans-serif", fontWeight: 700 }}
                  >
                    <span>{`Inscrição Nº ${subs.id} - ${tournamentInfo?.name || ""}`}</span>
                  </Typography>
                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <span><strong>Nome:</strong>{" "}{subs.fighters ? subs?.fighters?.name : subs?.user?.name}</span>
                  </Typography>
                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <span><strong>Equipe:</strong>{" "}{subs.fighters
                      ? subs?.fighters?.gym?.toLocaleUpperCase()
                      : subs?.user?.gym?.toLocaleUpperCase()}</span>
                  </Typography>
                  <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                    <span><strong>Categoria(s):</strong>{" "}{`${subs.genre?.toLocaleUpperCase()} (${subs.category?.split(";")[0]?.toLocaleUpperCase()}) / ${subs.belt?.toLocaleUpperCase()} / ${subs.weight?.split(";")[0]?.toLocaleUpperCase()}`}</span>
                  </Typography>

                  {tournamentInfo?.isFederated && (
                    <Box sx={{ mt: 0.5 }}>
                      <FederationBadge
                        verified={subs.affiliationVerified}
                        federationSlug={subs.affiliationFederationSlug || tournamentInfo?.federationSlug}
                      />
                    </Box>
                  )}

                  {subs.tShirts && (
                    <Typography sx={{ fontFamily: "inter, sans-serif" }}>
                      <span><strong>Camisa:</strong>{" "}{`${subs.tShirts.measure?.toLocaleUpperCase()} (${subs.tShirts?.size.toLocaleUpperCase()}) - ${subs.tShirts.color?.toLocaleUpperCase()}`}</span>
                    </Typography>
                  )}

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      mt: 1,
                      gap: 1,
                      alignItems: "center",
                    }}
                  >
                    <LoadingButton
                      onClick={() =>
                        redirectToPagePayment(subs.id, tournamentInfo.id)
                      }
                      loading={
                        isPaymentLoading && selectedEnrollment === subs.id
                      }
                      loadingIndicator={
                        <CircularProgress
                          color="inherit"
                          size={20}
                          sx={{ color: "white" }}
                        />
                      }
                      loadingPosition="center"
                      disabled={subs.status || !canPaySubscriptionTournament}
                      sx={{
                        backgroundColor: "#ac0000ff",
                        fontWeight: "bold",
                        color: subs.status ? "green" : "white",
                        borderRadius: 1,
                        fontFamily: "inter, sans-serif",
                        "&:hover": { backgroundColor: "#2c2c2c" },
                        "&.Mui-disabled": {
                          fontWeight: subs.status ? "bold" : "",
                          backgroundColor: subs.status
                            ? "#218802ff"
                            : "#b0b0b0",
                          color: subs.status ? "#ffffffe8" : "#666",
                          opacity: 1,
                        },
                      }}
                    >
                      {isPaymentLoading && selectedEnrollment === subs.id ? (
                        <span style={{ visibility: "hidden" }}>Pagar</span>
                      ) : subs.status ? (
                        <span>Pago</span>
                      ) : !canPaySubscriptionTournament ? (
                        <span>Pagamento Encerrado</span>
                      ) : (
                        <span>Pagar</span>
                      )}
                    </LoadingButton>

                    <LoadingButton
                      disabled={!canEditSubsTournament}
                      onClick={
                        canEditSubsTournament
                          ? () =>
                              handleEditFighter(subs.id, tournamentInfo?.slug)
                          : undefined
                      }
                      sx={{
                        backgroundColor: "#373737",
                        color: "white",
                        borderRadius: 1,
                        fontWeight: "bold",
                        fontFamily: "inter, sans-serif",
                        "&:hover": { backgroundColor: "#2c2c2c" },
                        "&.Mui-disabled": {
                          backgroundColor: "#b0b0b0", // cor de fundo quando desabilitado
                          color: "#666", // cor do texto quando desabilitado
                          opacity: 1, // evita o esmaecimento padrão do MUI
                        },
                      }}
                    >
                      {canEditSubsTournament
                        ? <span>Correção</span>
                        : <span>Correção Encerrada</span>}
                    </LoadingButton>

                    <Tooltip
                      title={
                        tournamentInfo?.canEditSubscriptions
                          ? "Editar inscrição"
                          : "Correção encerrada"
                      }
                      arrow
                    >
                      <EditIcon
                        sx={{
                          cursor: canEditSubsTournament ? "pointer" : "default",
                          color: canEditSubsTournament
                            ? "black"
                            : "rgba(122, 122, 122, 0.57)",
                        }}
                        onClick={
                          tournamentInfo?.canEditSubscriptions
                            ? () =>
                                handleEditFighter(subs.id, tournamentInfo?.slug)
                            : undefined
                        }
                      />
                    </Tooltip>
                    <Tooltip title="Histórico de alterações" arrow>
                      <HistoryIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => showHistorySubsModal(subs.id)}
                      />
                    </Tooltip>

                    {subs.championGuarantee && (
                      <Tooltip title="Você adquiriu a garantia campeã!" arrow>
                        <EmojiEventsIcon color="warning" />
                      </Tooltip>
                    )}
                  </Box>
                </Box>
              </Paper>
            );
          })}
          <div ref={loaderRef} style={{ minHeight: 20 }} />
        </Box>
      </Container>

      <HistoryModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        history={historyData}
        title="Inscrição"
        fieldLabels={{
          weight: "Peso",
          category: "Categoria",
          age: "Idade",
          belt: "Faixa",
        }}
        hiddenFields={[
          "tournamentId",
          "valueSubscription",
          "combo_subscription",
          "userId",
          "genre",
          "fightersId",
          "status",
          "tshirtId",
          "championGuarantee",
          "priceChampionGuarantee",
        ]}
      />

      <Zoom in={visible}>
        <Fab
          color="primary"
          size="medium"
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            backgroundColor: "#373737",
            borderRadius: "50%",
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Zoom>
    </>
  );
};

export default Subscription;
